import charMap from './charMap';

/**
 * @param {String} str
 * @return {String} same, with leading/trailing and extraneous internal whitespace removed
 */
function compressWhitespace(str) {
    if (!str) {
        return str;
    }
    return str.trim().replace(/\s+/g, ' ');
}

function formatAddressValue(input) {
    if (!input) {
        return undefined;
    }

    return input.split(', ').slice(0, 2).join(', ');
}

function formatAddressComponents(city, state, countryShort, countryLong) {
    let formattedAddressComponents = [city, state];
    if (!['US', 'CA'].includes(countryShort)) {
        formattedAddressComponents = [city, countryLong || countryShort];
    }

    return formattedAddressComponents
        .filter(Boolean)
        .join(', ');
}

/**
 * @param {String} str - UTF-8 string
 * @return {String} same, minus diacritics and extended characters
 */
function removeDiacritics(str = '') {
    return str.split('')
        .map((char) => {
            return charMap[char] || char;
        })
        .join('');
}

function sanitizeUUID(str = '') {
    if (!str) {
        return undefined;
    }

    return compressWhitespace(str)
        .replace(/[^a-fA-F0-9-]/g, '');
}

/**
 * @param {String} str any string
 * @return {String} converted to camelCase
 */
function toCamelCase(str) {
    return str.replace(/(?:^\w|[A-Z]|\b\w)/g, (letter, index) => {
        return index === 0
            ? letter.toLowerCase()
            : letter.toUpperCase();
    }).replace(/\s+/g, '');
}

/**
 * @param {String} str any string
 * @return {String} converted to snake-case
 */
function toSnakeCase(str) {
    if (str) {
        return str
            .replace(/(?!^)([A-Z]|[0-9])/g, ' $1')
            .replace(/[_\s]+(?=[a-zA-Z|0-9])/g, '_')
            .toLowerCase();
    }

    return undefined;
}

const processNewParagraph = (data) => {
    const rawContent = data;

    return Object.keys(rawContent).reduce((contentMap, key) => {
        const cleanedContent = typeof rawContent[key] === 'string'
            ? rawContent[key].replace(/\r?\n|\r|<|>/g, '').replace(/{newParagraph}/g, '\n\n')
            : rawContent[key];

        return {
            ...contentMap,
            [key]: cleanedContent,
        };
    }, {});
};

export {
    compressWhitespace,
    formatAddressComponents,
    formatAddressValue,
    processNewParagraph,
    removeDiacritics,
    sanitizeUUID,
    toCamelCase,
    toSnakeCase,
};
